/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { AzureBlobStore } from 'src/core/stores/AzureBlobStore';

export const getSplittedPath = (name: string): string[] => name.split('/');

export const getCurrentId = (name: string, prevFolderNames: string[]) => {
    const currentPath = [...prevFolderNames, name];
    return currentPath.join('/');
};

export const getUniqueFolders = (folders: AzureBlobStore[], index: number) =>
    folders.reduce((acc, val) => {
        if (!acc.some(item => getSplittedPath(item.name)[index] === getSplittedPath(val.name)[index])) {
            acc.push(val);
        }
        return acc;
    }, []);

export const hasSamePath = (currentPath: string[], filePath: string[]) => currentPath.every((prev, index) => prev === filePath[index]);

export const isFolderRow = (type: string) => type === 'folder';

export const getUniqueBlobFiles = (prevFiles: AzureBlobStore[], newFile: AzureBlobStore[]) =>
    [...prevFiles, ...newFile].reduce((acc, val) => {
        if (!acc.some(item => item.id === val.id)) {
            acc.push(val);
        }
        return acc;
    }, []);

export const getCurrentFolders = (files: AzureBlobStore[], prevFolderNames: string[]) => {
    const folders = files.filter(file => hasSamePath(prevFolderNames, getSplittedPath(file.name)));

    const uniqueFolders = getUniqueFolders(folders, prevFolderNames.length);

    return uniqueFolders.map(item => {
        const splittedName = getSplittedPath(item.name);
        return {
            ...item,
            name: splittedName[prevFolderNames.length],
            id: getCurrentId(splittedName[prevFolderNames.length], prevFolderNames),
            blobType: splittedName.length - 1 === prevFolderNames.length ? item.blobType : 'folder'
        };
    });
};
